import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Fairsph from "../../assets/pic/fairs.jpg"
import {Helmet} from "react-helmet";

const FairsEn = ()=>{
    return(
        <div className='fairs-wrap'>
            <Helmet>
                <title>Virtual exhibitions</title>
                <meta name="description" content="the internet shop has significant advantages over the physical store in terms of sales, communication with the customers, word-of-mouth advertisement, and many other parameters." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>Virtual exhibitions</h1>
                <img src={Fairsph} alt="Virtual exhibitions"/>
                <p>
                    It is evident that if you compare a physical store confined to a specific geographical location to an internet shop that is active across the country or even internationally, the internet shop has significant advantages over the physical store in terms of sales, communication with the customers, word-of-mouth advertisement, and many other parameters.
                </p>
                <p>
                    Similarly, the same is true regarding physical and virtual (online) exhibitions. For instance, the book exhibition used to be held physically in a specific location every year, but the coronavirus pandemic resulted in the exhibition being held online which resulted in higher interaction of people with the book exhibition.
                </p>
                <p>
                    One could suggest that the most essential factor in this regard is the independence of virtual (online) exhibitions from time and place so that everyone across the countries and cities could take part in the virtual exhibition at any time of the day.
                </p>
                <p>
                    Virtual exhibitions are held on the Web (the internet) and result in insignificant amounts of time and money for both participants and organizers being saved due to the elimination of the physical location and frequent visits to the location.
                </p>
                <p>
                    There are a variety of ways to hold a virtual or online exhibition, but the most effective method is the one resulting in the highest interaction with visitors. To this end, platforms with the possibility of high-quality video and audio interaction, text conversation and interaction (chatting), sharing files (particularly catalogs), and displaying announcements are recommended.
                </p>
                <p>
                    BellMeet comprehensive online meeting platform, the only knowledge-based and native platform, with the most complete interactive tools mentioned above, is prepared to host your network meetings or events so that you can have a more pleasant and efficient experience than in-person meetings.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default FairsEn